enum FILTER_KEYS {
  LANGUANGE_FILTER = 'language-filter',
  CATEGORIES_FILTER = 'categories-filter',
  DISH_SIZE_FILTER = 'dish-size-filter',
  MENU_TYPE_FILTER = 'menu-type-filter',
  ALLERGENS_FILTER = 'allergens-filter'
}

enum TABLE_KEYS {
  TABLES_LIST = 'tables-list'
}

export { FILTER_KEYS, TABLE_KEYS }
